@if(state === 'warning'){
  <h2 rds-dialog-header>Do you want to proceed?</h2>
  <div rds-dialog-content>
    It seems as if some reccommended inputs are still empty.
    Do you want to go back to editing, or proceed with updating this element?
  </div>
  <div rds-dialog-actions-container align="end">
    <button rds-secondary-button [rds-dialog-close]="false" size="s">Send me back to editing</button>
    <button rds-primary-button [rds-dialog-close]="true" size="s">Proceed with the update</button>
  </div>
}
@else if(state == "invalid_priority"){
  <h2 rds-dialog-header>Cannot update due to invalid inputs</h2>
  <div rds-dialog-content>
    Priority selection is mandatory. Please select the priority before proceeding.
  </div>
  <div rds-dialog-actions-container align="end">
    <button rds-primary-warning-button [rds-dialog-close]="false" size="s">Send me back to editing</button>
  </div>
}
@else if(state == "required"){
  <h2 rds-dialog-header>Cannot update due to invalid inputs</h2>
  <div rds-dialog-content>
    It seems as if some required inputs are still empty. Please check your submission again and fill out any required
    fields (marked with a <b class="c-error">*</b>)
  </div>
  <div rds-dialog-actions-container align="end">
    <button rds-primary-warning-button [rds-dialog-close]="false" size="s">Send me back to editing</button>
  </div>
}
@else if (state == 'delete'){
  <h2 rds-dialog-header>Do you want to proceed?</h2>
  <div rds-dialog-content>
    You are about to delete this entry.
    A deletion cannot be undone. Are you sure that you want to proceed?
  </div>
  <div rds-dialog-actions-container align="end">
    <button rds-secondary-button [rds-dialog-close]="false" size="s">No, don't delete this entry</button>
    <button rds-primary-warning-button [rds-dialog-close]="true" size="s">Yes, delete this entry</button>
  </div>
}
@else{
  <h2 rds-dialog-header>This should not have happened</h2>
  <div rds-dialog-content>
    We apologise for the inconvenience, but this dialog should never be shown.
    Please contact someone responsible.
  </div>
  <div rds-dialog-actions-container align="end">
    <button rds-secondary-button [rds-dialog-close]="false" size="s">Send me back to editing</button>
  </div>
}

